import { RestService } from "@abp/ng.core";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})

export class CustomServiceService {
      apiName = 'Default';

  constructor(private readonly restService: RestService,){

  }
  
  getUserPermission = (serviceName: string) =>
    this.restService.request<any, boolean>(
      {
        method: 'POST',
        url: `/api/user-detail/check-role-service-permissions?requestedService=${serviceName}`,
      },
      { apiName: this.apiName }
    );
}